exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status {\n    margin-bottom: 5px;\n}\n\n.shift-status {\n    border-radius: 5px;\n    font-weight: 100;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/shared/components/attendance-status-present/attendance-status-present.component.css
// module id = ../../../../../src/app/shared/components/attendance-status-present/attendance-status-present.component.css
// module chunks = main